import { render, staticRenderFns } from "./ProjectCollectButton.vue?vue&type=template&id=03d3b9e4&scoped=true&"
import script from "./ProjectCollectButton.vue?vue&type=script&lang=js&"
export * from "./ProjectCollectButton.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCollectButton.vue?vue&type=style&index=0&id=03d3b9e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d3b9e4",
  null
  
)

export default component.exports